import React from 'react';
import { Steps, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface StepData {
  title: string;
  description?: string;
}

interface StepperProps {
  steps: string[] | StepData[];
  currentStep: number;
  layout?: 'horizontal' | 'vertical';
}

export const Stepper: React.FC<StepperProps> = ({
  steps,
  currentStep,
  layout = 'vertical',
}) => {
  const items = steps.map((step, index) => {
    const stepTitle = typeof step === 'string' ? step : step.title;
    const stepDescription =
      typeof step === 'object' ? step.description : undefined;

    // Determine if this step has long description
    const hasLongDescription = stepDescription && stepDescription.length > 50;

    return {
      title: (
        <div>
          <Text
            style={{
              color:
                index === currentStep
                  ? '#1890ff'
                  : index < currentStep
                    ? '#52c41a'
                    : '#8c8c8c',
              fontWeight:
                index === currentStep ? 600 : index < currentStep ? 500 : 400,
              fontSize: layout === 'vertical' ? 14 : 12,
            }}
          >
            {stepTitle}
          </Text>
          {index === currentStep && (
            <div style={{ marginTop: 4 }}>
              <Text
                style={{
                  fontSize: 11,
                  color: '#52c41a',
                  fontWeight: 500,
                }}
              >
                Current step
              </Text>
            </div>
          )}
        </div>
      ),
      description: stepDescription ? (
        <Text
          style={{
            color: index === currentStep ? '#595959' : '#8c8c8c',
            fontSize: layout === 'vertical' ? 12 : 11,
            lineHeight: 1.4,
            display: '-webkit-box',
            WebkitLineClamp: hasLongDescription
              ? layout === 'vertical'
                ? 2
                : 1
              : 'none',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {stepDescription}
        </Text>
      ) : undefined,
      icon:
        index < currentStep ? (
          <CheckCircleOutlined style={{ color: '#52c41a' }} />
        ) : undefined,
    };
  });

  return (
    <Steps
      current={currentStep}
      direction={layout === 'vertical' ? 'vertical' : 'horizontal'}
      items={items}
      size="small"
    />
  );
};
